import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { TIERS_PER_FETCH } from '../constants';
import { getTierStreamId } from '../helpers';
function* handleInitTierStream() {
    const streamId = getTierStreamId();
    const isStreamInitialized = yield select(selectors.isInitialized, streamId);
    if (isStreamInitialized) {
        return;
    }
    yield all([
        put(withOffset.actions.initialize({
            streamId,
            itemsPerFetch: TIERS_PER_FETCH
        })),
        put(withOffset.actions.fetch(streamId))
    ]);
}
export default handleInitTierStream;

//# sourceMappingURL=initTierStream.js.map